module.exports = __webpack_public_path__ + "static/img/cas-cold-atom.4062b86.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/cas-cold-atom.jpeg
// module id = TA5k
// module chunks = 10